import { Component, Directive, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SignatureService } from '../../providers/signature.service';
import { DialogService } from '../dialog.service';

@Component({
  selector: 'app-selectimage',
  templateUrl: './selectimage.component.html',
  styleUrls: ['./selectimage.component.css']
})
export class SelectimageComponent implements OnInit {
  @Input() doc: any;
  @Input() page: any;
  @Input() onAddImage: any;
  @Input() clientMode: boolean;

  imgSigLoading = false;
  imagSignature = undefined;
  
  eventListenerActive = false;
  dragClass: string = '';
  image: any;

  @HostListener("dragover", ["$event"]) public onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.dragClass = 'dropHere-active';
  }

  @HostListener("dragleave", ["$event"]) public onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.dragClass = 'dropHere-inactive';
  }

  @HostListener('drop', ['$event']) public onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();

    let files: File[] = [];
    let firstFile: File;
    for (let i = 0; i < evt.dataTransfer.files.length; i++) {
      firstFile = evt.dataTransfer.files[0];

    }

    this.upload(firstFile, true);
    this.dragClass = 'dropHere-inactive';
  }

  constructor(public activeModal: NgbActiveModal,
    private translateService: TranslateService,
    private dialogs: DialogService,
    private signature: SignatureService) { }

  ngOnInit(): void {
    //this.activate();
  }

  activate() {
    this.addFileInputListener();
  }

  addFileInputListener() {
    if (!this.eventListenerActive) {
      var uploadTag = document.getElementById("insertImgInput");
      if (uploadTag) {
        this.eventListenerActive = true;
        //uploadTag.addEventListener('change', this.upload, false);
      }
    }
  }

  async addImage() {
    await this.activeModal.close(this.image);
    //TODO onAddImage(this.image);
  }

  async cancel() {
    await this.activeModal.close(undefined);
  }

  fileDropped(files) {
    this.dragClass = 'dropHere-inactive';
    this.upload(files[0], true);
  }

  openFileBrowser() {
    var uploadTag = document.getElementById("insertImgInput");
    if (uploadTag) uploadTag.click();
  }

  uploadFileFromFileInput() {
    this.upload(undefined);
  }

  upload(paramF, isDragNDrop: boolean = false) {
    var f = document.getElementById("insertImgInput") as HTMLInputElement;

    var file;
    if (isDragNDrop) {
      if (paramF)
        file = paramF;
      else
        file = f.files[0];
    } else {
      file = f.files[0];
    }

    if (file === undefined || file === null)
      return;
    var fileType = "";

    if (file.type === "image/jpeg" || file.name.toLowerCase().endsWith(".jpg") || file.name.toLowerCase().endsWith(".jpeg")) {
      fileType = "jpg";
    } else if (file.type === "image/gif" || file.name.toLowerCase().endsWith(".gif")) {
      fileType = "gif";
    } else if (file.type === "image/png" || file.name.toLowerCase().endsWith(".png")) {
      fileType = "png";
    } else if (file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic")) {
      fileType = "heic";
    }

    if (fileType === "") {
      this.dialogs.openMessageDialog(this.translateService.instant('SelectDocument'), this.translateService.instant('UnsupportedFileFormat'));
      this.resetFileInput();
      return;
    }

    this.imgSigLoading = true;
    /*if (!$scope.$$phase)
      $scope.$apply();*/

    var data = new FormData();
    data.append('Image', file);

    this.imgSigLoading = true;

    this.signature.prepareImageToInsertToDoc(this.doc, this.page, data, fileType).then(
      data => {
        this.imgSigLoading = false;
        if (data !== undefined && data['status'] === 0) {
          this.image = data['image'];
        }
      }
    );
  }

  resetFileInput() {
    var form = document.getElementById("insertImgInputForm") as HTMLFormElement;
    if (form) form.reset();
  }

}
